import { useMsal } from "@azure/msal-react";
import { Button } from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

function LogoutButton() {
    const { instance } = useMsal();

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
    };
    
    return (
    
        <Button variant="contained" startIcon={<AccountCircleIcon />} onClick={() => handleLogout()}>
                    Logout
        </Button>
        
    );
}

export default LogoutButton;